module.exports = __webpack_public_path__ + "static/media/destination-digital-templates.e2dc688d.png";